import { c as _c } from "react/compiler-runtime";
import { useMarkupsViewQueryParams } from "@pages/project-details/project-markups/calendar/use-markups-view-query-params";
import { BulkExportMarkups } from "@pages/project-details/project-markups/project-markups-bulk-actions/bulk-export-markups";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
/** Export of the annotations toolbar: the selected annotations, otherwise all the shown ones */
export function MarkupsToolbarExport(t0) {
  const $ = _c(10);
  const {
    projectId,
    markups
  } = t0;
  const {
    viewMode
  } = useMarkupsViewQueryParams();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("markups");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedMarkups = useAppSelector(t1);
  let t2;
  if ($[1] !== projectId) {
    t2 = getProjectByIdSelector(projectId);
    $[1] = projectId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const project = useAppSelector(t2);
  const areMarkupsSelected = viewMode === "table" && selectedMarkups.length > 0;
  const exportedMarkups = areMarkupsSelected ? selectedMarkups : markups;
  let t3;
  if ($[3] !== exportedMarkups) {
    t3 = exportedMarkups.map(_temp);
    $[3] = exportedMarkups;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = project?.name ?? "";
  let t5;
  if ($[5] !== areMarkupsSelected || $[6] !== projectId || $[7] !== t3 || $[8] !== t4) {
    t5 = <BulkExportMarkups projectId={projectId} markupIds={t3} projectName={t4} areEntitiesSelected={areMarkupsSelected} buttonType="standard" />;
    $[5] = areMarkupsSelected;
    $[6] = projectId;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(markup) {
  return markup.id;
}